module.exports = __webpack_public_path__ + "img/qingyang2.df57a7bb.png";